import { useEffect } from "react";
import M from 'materialize-css/dist/js/materialize.min';

const Fees = () => {
    useEffect(() => {
        var tabs = document.querySelector('.tabfees');
        M.Tabs.init(tabs, {});
    }, []);

    return ( 
        <div className="container" id="fees-structure">
            <div className="topic-cont mb-5">
                <span className="is-size-6-touch is-size-5-desktop grey-text text-lighten-3">Fees Structure</span>
            </div>
            <div className="row mt-5">
                <div className="col s12 m11">
                    <ul className="tabs tabfees">
                        <li className="tab col s3"><a href="#fees1" className="active main-color-text has-text-weight-bold">NC</a></li>
                        <li className="tab col s3"><a  href="#fees2" className="main-color-text has-text-weight-bold">ND</a></li>
                        <li className="tab col s3"><a href="#fees3" className="main-color-text has-text-weight-bold">HND</a></li>
                    </ul>
                </div>
                <div id="fees1" className="col s12 m11 mt-6 px-5">
                    <div className="row">
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Full Time</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$180.00</h5>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Part Time</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$190.00</h5>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Distance/Online</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$240.00</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="fees2" className="col s12 m11 mt-6 px-5">
                    <div className="row">
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Full Time</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$190.00</h5>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Part Time</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$200.00</h5>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Distance/Online</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$265.00</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="fees3" className="col s12 m11 mt-6 px-5">
                    <div className="row">
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Block Release</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$210.00</h5>
                            </div>
                        </div>
                        <div className="col s12 m4 l4">
                            <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                <h5 className="grey-text text-darken-2 center mt-1 mb-5 is-size-4">Distance/Online</h5>
                                <h5 className="green-text text-darken-3 has-text-weight-semibold center my-5 is-size-4">$290.00</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="center mt-4 pb-6">
                <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span>All fees are charged per term and quoted in usd ($).</p>
            </div>
        </div>
     );
}
 
export default Fees;